import { useContext, useEffect } from "react";
import { ControlContext } from "../../../ControlContext.jsx";

import FloatProfileSegment from "./FloatProfileSegment";

export default function FloatProfile({
  pWidthOverride,
  pDepthOverride,
  pInnerDepthOverride,
  pInnerWidthOverride,
  widthOverride,
  heightOverride,
}) {
  const {
    printWidth,
    printHeight,
    borderWidth,
    borderHeight,
    floatProfileWidth,
    floatProfileDepth,
    profileFrontMaterial,
    profileSideMaterial,
    frameExposure,
    frameToneMapping,
  } = useContext(ControlContext);
  
  useEffect(() => {
    if (profileFrontMaterial) {
      profileFrontMaterial.toneMapped = true;
      profileFrontMaterial.toneMapping = frameToneMapping;
      profileFrontMaterial.toneMappingExposure = frameExposure;
    }
    if (profileSideMaterial) {
      profileSideMaterial.toneMapped = true;
      profileSideMaterial.toneMapping = frameToneMapping;
      profileSideMaterial.toneMappingExposure = frameExposure;
    }
  }, [profileFrontMaterial, profileSideMaterial, frameToneMapping, frameExposure]);

  const totalWidth = widthOverride
    ? widthOverride
    : printWidth + 2 * borderWidth;
  const totalHeight = heightOverride
    ? heightOverride
    : printHeight + 2 * borderHeight;

  const profileWidth = pWidthOverride ? pWidthOverride : floatProfileWidth;
  const profileDepth = pDepthOverride ? pDepthOverride : floatProfileDepth;

  const props = {
    totalWidth,
    totalHeight,
    profileWidth,
    profileDepth,
    frontMaterial: profileFrontMaterial,
    sideMaterial: profileSideMaterial,
    innerDepthOverride: pInnerDepthOverride,
    innerWidthOverride: pInnerWidthOverride,
  };

  return (
    <>
      <FloatProfileSegment {...props} rotation={0} />
      <FloatProfileSegment {...props} rotation={Math.PI} />
      <FloatProfileSegment
        {...props}
        totalWidth={totalHeight}
        totalHeight={totalWidth}
        rotation={Math.PI / 2}
      />
      <FloatProfileSegment
        {...props}
        totalWidth={totalHeight}
        totalHeight={totalWidth}
        rotation={-Math.PI / 2}
      />
    </>
  );
}
